import { Box, Text, Link, Image, VStack, Heading, useMediaQuery } from '@chakra-ui/react'
import { User } from '../../../types/types'
import avatarDefault from '@core/assets/images/avatar_default.svg'

interface UserCardProps {
    user: User
}

export function useDesktopMediaQuery() {
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })
    return isDesktop
}

const UserCard = ({ user }: UserCardProps) => {
    const { firstName, lastName, title, phone, email, image } = user
    const isDesktop = useDesktopMediaQuery()

    return (
        <Box as="figure" overflow="hidden">
            <Image 
                src={image || avatarDefault} 
                alt={`${firstName} ${lastName}`} 
                borderRadius="8px" 
                boxSize={isDesktop ? "280px" : "166px"} 
                objectFit='cover'
            />
            <VStack as="figcaption" spacing={2} align="left" mt={4} width={isDesktop ? "280px" : "166px"}>
                <Heading as="h3" color="#1A1A1A" fontWeight="600" fontSize={isDesktop ? "xl" : "md"}>
                    {firstName} {lastName}
                </Heading>
                {title && <Text color="#1A1A1A" fontWeight="500" fontSize="sm">{title}</Text>}
                <VStack spacing={2} align="left" mt={2}>
                    {phone && <Text color="#404040" fontWeight="400" fontSize="sm">{phone}</Text>}
                    {email && (
                        <Link 
                            href={`mailto:${email}`} 
                            fontWeight="400" 
                            fontSize="sm" 
                            textDecoration="underline"
                            _hover={{ color: "#2F80ED" }}
                        >
                            {email}
                        </Link>
                    )}
                </VStack>
            </VStack>
        </Box>
    )
}

export default UserCard;
